import { Asset } from "./asset";
import { InboundAssetRetrievalShipment, OutboundAssetRetrievalShipment } from "./assetRetrievalShipment";
import { Location } from "./location";
import { Organization } from "./organization";
import { User } from "./user";

export interface AssetRetrieval {
  id: string;
  employeeAddress: string;
  employeeAddressCity: string;
  employeeAddressCountry: string;
  employeeAddressState: string;
  employeeAddressTwo: string;
  employeeAddressZipCode: string;
  employeeEmail: string;
  employeeFirstName: string;
  employeeLastName: string;
  employeePhone: string;
  inboundAssetRetrievalShipment?: InboundAssetRetrievalShipment;
  location: Location;
  manufacturer: string;
  model: string;
  orderNumber: string;
  organization: Organization;
  outboundAssetRetrievalShipment?: OutboundAssetRetrievalShipment;
  priceInCents: number;
  serialNumber: string;
  state: string;
  uuid: string;
  insuranceOption?: any;
  createdAt: string;
  assetRetrievalRemindersCount: number;
  remindersMutedAt: string;
  user: User;
  virtualPickup: boolean;
  returnRecipientName: string;
  returnRecipientFirstName: string;
  returnRecipientLastName: string;
  returnRecipientEmail: string;
  returnRecipientCompany: string;
  returnRecipientAddress: string;
  returnRecipientAddressTwo: string;
  returnRecipientAddressCity: string;
  returnRecipientAddressState: string;
  returnRecipientAddressZipCode: string;
  returnRecipientAddressCountry: string;
  isCustomAddress?: boolean;
  followupEscalationEmailSentAt: string;
}

export interface AssetRetrievalBulkOrderDetails {
  fileSignedId: string;
  locationId: string;
  totalRows: number;
  paymentType: string;
  insuranceOption: string;
  returnRecipientFirstName: string;
  returnRecipientLastName: string;
  returnRecipientEmail: string;
  returnRecipientCompany: string;
  returnRecipientAddress: string;
  returnRecipientAddressTwo: string;
  returnRecipientAddressCity: string;
  returnRecipientAddressState: string;
  returnRecipientAddressZipCode: string;
  returnRecipientAddressCountry: string;
  isCustomAddress?: boolean;
  virtualPickup?: boolean;
}

export enum DeviceType {
  laptop = "laptop",
  mobile_phone = "mobile phone",
  tablet = "tablet",
  desktop = "desktop",
  monitor = "monitor",
}

export enum BoxType {
  laptop = "laptop",
  laptopTablet = "laptop_tablet",
  laptopMobile = "laptop_mobile",
  tablet = "tablet",
  tabletMobile = "tablet_mobile",
  mobilePhone = "mobile_phone",
  desktop = "desktop",
  monitor = "monitor",
  bulk = "bulk",
}

export type AssetRetrievalDevice = {
  id: string;
  deviceType: DeviceType;
  boxSize?: string;
  manufacturer?: string | null;
  model?: string | null;
  serialNumber?: string | null;
  asset?: Asset | null;
  assetRetrieval: AssetRetrieval;
};
